import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as PlaybackActions from '../../actions/Playback';
const States = {
    'like': 'UP',
    'dislike': 'DOWN'
};
export default function ThumbButton(props) {
    var _a, _b, _c;
    const dispatch = useDispatch();
    const { thumbsUp, thumbsDown } = useSelector((state) => state.PlaybackStates);
    const { size, icon } = props;
    const value = States[icon] === 'UP' ? thumbsUp : thumbsDown;
    const variant = ((_a = value) === null || _a === void 0 ? void 0 : _a.state) === 'ON' ? 'accent' : 'primary';
    const text = (_b = value) === null || _b === void 0 ? void 0 : _b.descriptions[(_c = value) === null || _c === void 0 ? void 0 : _c.state];
    if (!value) {
        return React.createElement("div", { style: { display: 'none' } });
    }
    return (React.createElement("music-button", { "aria-label": text, onmusicActivate: handleClick, variant: variant, "icon-name": icon, "icon-only": true, size: size || 'small' }));
    function handleClick(e) {
        if (!e.target.disabled && value) {
            if (value.state === 'OFF') {
                dispatch({ type: PlaybackActions[`THUMBS_${States[icon]}`] });
            }
            else {
                dispatch({ type: PlaybackActions[`UNDO_THUMBS_${States[icon]}`] });
            }
        }
    }
}
;
